import { FC } from "react";
import { Modal, Tabs } from "@/ui";
import { Raw } from "./tabs";
import styles from "../Treez.module.scss";

const TreezObjectModal: FC<ITreezObjectModal> = ({
    handleModalToggle,
    isModalOpen,
    object,
    title = "Product Details",
}) => {
    return (
        <Modal
            className="treez_modal_product"
            onOpenChange={open => {
                if (!open) handleModalToggle();
            }}
            open={isModalOpen}
            size="lg"
            title={title}
        >
            <div className={styles.modalBody}>
                <Tabs defaultValue="raw">
                    <Tabs.List>
                        <Tabs.Trigger value="raw">Raw</Tabs.Trigger>
                    </Tabs.List>
                    <Tabs.Content value="raw">
                        <Raw object={object} />
                    </Tabs.Content>
                </Tabs>
            </div>
        </Modal>
    );
};

export default TreezObjectModal;

interface ITreezObjectModal {
    handleModalToggle: () => void;
    isModalOpen: boolean;
    object: any;
    title?: string;
}
